"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TaxTypeSchemaProperties = exports.TaxTypeSchema = void 0;
const zod_1 = require("zod");
const schema_properties_interface_1 = require("./schema-properties-interface");
exports.TaxTypeSchema = zod_1.z.object({
    id: zod_1.z.string().optional(),
    name: zod_1.z.string(),
    inclusive: zod_1.z.boolean(),
    percentage: zod_1.z.number(),
    region: zod_1.z.string(),
    tax_rates: zod_1.z.array(zod_1.z.string()),
});
exports.TaxTypeSchemaProperties = {
    collectionName: "taxTypes",
    deleteMode: schema_properties_interface_1.DeleteMode.None,
};
//# sourceMappingURL=tax-type-schema.js.map